import Vue from "vue";
import Vuex from "vuex";
import createLogger from "vuex/dist/logger";

import {service as photoService} from "@/services/photo"
import {statusService} from "@/services/admin";
import {visitService, service as addressService} from '@/services/address';
import {clientService} from '@/services/admin';
import {planningService} from "@/services/planner";
import {sharedClientService} from '@/services/shared'


/* See below for the mutations that are used in vuex */

export const PUT_ADDRESS = 'PUT_ADDRESS'
export const PUT_PHOTO_URLS = 'PUT_PHOTO_URLS'
export const LOGGED_IN = 'LOGGED_IN'
export const OPEN_CAMERA = 'OPEN_CAMERA'
export const CLOSE_CAMERA = 'CLOSE_CAMERA'
export const ENABLE_USER_MODE = 'ENABLE_USER_MODE'
export const ENABLE_EXPERT_MODE = 'ENABLE_EXPERT_MODE'
export const CANCEL_APPOINTMENT = 'CANCEL_VISIT'
export const SAVE_PLANNER_REMARK = 'SAVE_PLANNER_REMARK';

export const SURVEY_TYPE_PLANNER = 'planner';
export const SURVEY_TYPE_MECHANIC = 'mechanic';
export const UPDATE_PHONE_1 = 'UPDATE_PHONE_1';
export const UPDATE_PHONE_2 = 'UPDATE_PHONE_2';
export const UPDATE_JOB = 'UPDATE_JOB';
export const UPDATE_STATUS = 'UPDATE_STATUS';
export const UPDATE_STATUS_ADMIN = 'UPDATE_STATUS_ADMIN';
export const MECHANIC_READY = 'MECHANIC_READY';
export const UPDATE_CLIENTS = 'UPDATE_CLIENTS';
export const ADD_CLIENT = 'ADD_CLIENT';
export const DELETE_CLIENT = 'DELETE_CLIENT';
export const CHANGE_CLIENT = 'CHANGE_CLIENT';

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';
// const debug = false;

/* actual implementation of the vuex store */
export default new Vuex.Store({
  state: {
    clients: [],
    address: {
      surveyPlannerReady: false,
      surveyMechanicReady: false,
      surveyPlanner: {},
      surveyMechanic: {},
      remarks: [],
      remarkPlanner: null
    },
    photoUrls: [],
    surveyType: null,
    currentQuestionIndex: 0,
    maxQuestionIndex: 0,
    currentQuestion: null,
    loggedin: false,
    admin: false,
    showCamera: false,
    expert: false,
    showStatistics: false,
  },
  getters: {
    clientList: state => state.clients,
    currentSurveyPlannerReady: state => state.address.surveyPlannerReady,
    currentSurveyMechanicReady: state => state.address.surveyMechanicReady,
    currentStatus: state => state.address && statusService.resolveLabel(state.address.status),
    isLoggedIn: state => state.loggedin,
    currentQuestionIndex: state => state.currentQuestionIndex,
    maxQuestionIndex: state => state.maxQuestionIndex,
    activeAddress: state => state.address,
    photoUrls: state => state.photoUrls,
    isCameraVisible: state => state.showCamera,
    isAdmin: state => state.admin,
    isExpert: state => state.expert,
    showStatistics: state => state.showStatistics,
    surveyType: state => state.surveyType,
    currentHistory: state => state.address.remarks,
  },
  mutations: {
    [OPEN_CAMERA](state) {
      state.showCamera = true;
    },
    [CLOSE_CAMERA](state) {
      state.showCamera = false;
    },
    [UPDATE_PHONE_1](state, payload) {
      state.address.phoneNumber1 = payload;
    },
    [UPDATE_PHONE_2](state, payload) {
      state.address.phoneNumber2 = payload;
    },
    [UPDATE_JOB](state, payload) {
      state.address.job = payload;
    },
    [SAVE_PLANNER_REMARK](state, payload) {
      state.address.remarkPlanner = payload;
    },
    [LOGGED_IN](state, payload) {
      if (payload.roles.includes("ROLE_INFRA-APP-ADMIN")) {
        state.admin = true;
      }
      if (payload.roles.includes("ROLE_INFRA-APP-STATISTICS")) {
        state.showStatistics = true;
        state.expert = true; // Deprecated, admin must be used instead.
        state.admin = true;
      }
      state.loggedin = true;
    },
    [PUT_ADDRESS](state, payload) {
      state.address = payload;
      state.photoUrls = [];
    },
    [UPDATE_STATUS](state, payload) {
      state.address.status = payload.status;
      state.address.remarks.unshift(payload);
      state.address.surveyMechanicReady = payload.surveyMechanicReady;
      state.address.surveyPlannerReady = payload.surveyPlannerReady;
    },
    [UPDATE_STATUS_ADMIN](state, payload) {
      state.address.status = payload.status;
      state.address.remarks.unshift(payload);
    },
    [PUT_PHOTO_URLS](state, payload) {
      state.photoUrls = payload;
    },
    [ENABLE_USER_MODE](state, payload) {
      state.admin = !payload;
    },
    [ENABLE_EXPERT_MODE](state, payload) {
      state.expert = payload;
    },
    [MECHANIC_READY](state, payload) {
      state.address.status = payload.status;
      state.address.remarks.unshift(payload);
    },
    [CANCEL_APPOINTMENT](state, payload) {
      state.address.status = payload.status;
      state.address.visitDate = null;
      state.address.visitTime = null;
      state.address.remarks.unshift(payload);
    },
    [UPDATE_CLIENTS](state, payload) {
      state.clients = payload;
      state.clients.sort((a, b) => a.name.localeCompare(b.name));
    },
    [ADD_CLIENT](state, payload) {
      state.clients.push(payload);
      state.clients.sort((a, b) => a.name.localeCompare(b.name));
    },
    [DELETE_CLIENT](state, payload) {
      state.clients = state.clients.filter(client => client.id !== payload);
    },
    [CHANGE_CLIENT](state, payload) {
      state.clients = state.clients.map(client => {
        if (client.id === payload.id) {
          client.name = payload.clientName;
          client.areas = payload.areas.sort();
        }
        return client;
      })
    }
  },
  actions: {
    loggedIn({commit}, payload) {
      commit(LOGGED_IN, payload);
    },
    loadAddress({
                  commit,
                  dispatch
                }, payload) {
      commit(PUT_ADDRESS, payload);
      dispatch("loadPhotoUrls", payload);
    },
    enableUserMode({commit}, payload) {
      commit(ENABLE_USER_MODE, payload);
    },
    enableExpertMode({commit}, payload) {
      commit(ENABLE_EXPERT_MODE, payload);
    },
    mechanicReady({commit}) {
      let addressId = this.getters.activeAddress.uniqueIdAddress;
      visitService.setMechanicReady(addressId)
        .then(result => {
          commit(MECHANIC_READY, result.data);
        })
        // eslint-disable-next-line
        .catch(err => console.log("unable to set mechanic ready", err));
    },
    changeClient({commit}, payload) {
      clientService.change(payload.id, payload)
        // eslint-disable-next-line no-unused-vars
        .then(response => commit(CHANGE_CLIENT, payload));
    },
    saveClient({commit}, payload) {
      clientService.save(payload.client)
        // eslint-disable-next-line no-unused-vars
        .then((response) => {
          commit(ADD_CLIENT, response.data);
        });
    },
    deleteClient({commit}, payload) {
      clientService.delete(payload)
        // eslint-disable-next-line no-unused-vars
        .then(reponse => commit(DELETE_CLIENT, payload));
    },
    loadClients({commit}) {
      sharedClientService.resolveClients()
        .then((response) => {
          commit(UPDATE_CLIENTS, response.data.content);
          // eslint-disable-next-line no-unused-vars
        }).catch((error) => {
        commit(UPDATE_CLIENTS, []);
      })
    },
    loadPhotoUrls({
                    commit
                  }, payload) {
      photoService
        .getPhotoUrls(payload.uniqueIdAssignment, payload.uniqueIdAddress)
        .then(response => {
          response.data.sort();
          response.data.reverse();
          commit(PUT_PHOTO_URLS, response.data);
        })
        // eslint-disable-next-line
        .catch(err => console.log("unable to retrieve/save image url", err));
    },
    openCamera({commit}) {
      commit(OPEN_CAMERA);
    },
    closeCamera({commit}) {
      commit(CLOSE_CAMERA);
    },
    savePhoto({dispatch}, payload) {
      photoService.savePhoto(payload)
        // eslint-disable-next-line
        .then(val => dispatch("loadPhotoUrls", {
          uniqueIdAssignment: payload.get("uniqueIdAssignment"), uniqueIdAddress: payload.get("uniqueIdAddress")
        }))
        // eslint-disable-next-line
        .catch(err => console.log("unable to save photo", err));
    },
    savePlannerRemark({commit}, payload) {
      let address = this.getters.activeAddress;
      planningService.savePlannerRemark(address.uniqueIdAssignment, address.uniqueIdAddress, payload)
        // eslint-disable-next-line
        .then(val => {
          commit(SAVE_PLANNER_REMARK, payload);
        })
    },
    saveJob({commit}, payload) {
      let address = this.getters.activeAddress;
      addressService.changeJob(address.uniqueIdAddress, payload)
        // eslint-disable-next-line
        .then(val => {
          commit(UPDATE_JOB, payload);
        });
    },
    updateStatusAdmin({
                        commit
                      }, payload) {
      let address = this.getters.activeAddress;
      statusService.updateStatus(address.uniqueIdAssignment, address.uniqueIdAddress, payload)
        .then(result => {
          commit(UPDATE_STATUS_ADMIN, result.data);
        });
    },
    saveCancelLog({commit}, payload) {
      visitService.saveLog(this.getters.activeAddress.uniqueIdAddress, payload) // eslint-disable-next-line
        .then(result => {
          commit(CANCEL_APPOINTMENT, result.data);
        })
    },
    scheduleVisit({commit}, payload) {
      visitService.schedule(this.getters.activeAddress.uniqueIdAddress, payload)
        .then(e => commit(PUT_ADDRESS, e.data));
    },
    updatePhone1({commit}, payload) {
      commit(UPDATE_PHONE_1, payload);
    },
    updatePhone2({commit}, payload) {
      commit(UPDATE_PHONE_2, payload);
    },
    updateStatus({
                   commit
                 }) {
      statusService.resolveStatus(this.getters.activeAddress.uniqueIdAddress).then(response => commit(UPDATE_STATUS, response.data));
    }
  },
  strict: debug,
  plugins: debug ? [createLogger()] : []
});